/**
 * Time Range Selector Component
 * Dropdown for selecting dashboard time range (7, 30, 90 days, optional All Time).
 *
 * iter98 — adds optional `includeAllTime` prop (value 0 = All Time) so the
 * Customer Leads page can offer the broader range without breaking dashboard
 * defaults.
 */
import { Calendar } from "lucide-react";

const TIME_OPTIONS = [
  { value: 7, label: "Last 7 days" },
  { value: 30, label: "Last 30 days" },
  { value: 90, label: "Last 90 days" },
];

const ALL_TIME_OPTION = { value: 0, label: "All Time" };

const TimeRangeSelector = ({ value, onChange, disabled = false, includeAllTime = false, testId = "time-range-selector" }) => {
  const options = includeAllTime ? [...TIME_OPTIONS, ALL_TIME_OPTION] : TIME_OPTIONS;
  return (
    <div className="flex items-center gap-2">
      <Calendar className="w-4 h-4 text-gray-400" />
      <select
        value={value}
        onChange={(e) => onChange(Number(e.target.value))}
        disabled={disabled}
        className="text-sm font-medium text-gray-700 bg-white border border-gray-200 rounded-lg px-3 py-1.5 pr-8 
                   focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500
                   disabled:opacity-50 disabled:cursor-not-allowed
                   cursor-pointer hover:border-gray-300 transition-colors"
        style={{
          backgroundImage: `url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 20 20'%3e%3cpath stroke='%236b7280' stroke-linecap='round' stroke-linejoin='round' stroke-width='1.5' d='M6 8l4 4 4-4'/%3e%3c/svg%3e")`,
          backgroundPosition: "right 0.5rem center",
          backgroundRepeat: "no-repeat",
          backgroundSize: "1.25em 1.25em",
        }}
        data-testid={testId}
      >
        {options.map((option) => (
          <option key={option.value} value={option.value}>
            {option.label}
          </option>
        ))}
      </select>
    </div>
  );
};

export default TimeRangeSelector;
export { TIME_OPTIONS, ALL_TIME_OPTION };

